<script>
export default {
  name: "CellColorGps",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const rowValue = context.props.row;
    let qtyNavision = rowValue.equiposNavixion;
    let qtyNavixy = rowValue.trackers_count;
    if (qtyNavision > qtyNavixy) {
      return createElement(
        "span",
        {
          // class: "el-tag el-tag--danger el-tag--plain"
          style: {
            color: "blue",
            backgroundColor: "rgba(25, 133, 187, 0.281)",
            borderRadius: "50%",
            padding: "10%",
            width: "20%",
            height: "20%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }
        },
        val
      );
    } else if (qtyNavision < qtyNavixy) {
      return createElement(
        "span",
        {
          // class: "el-tag el-tag--danger el-tag--plain"
          style: {
            color: "red",
            backgroundColor: "rgba(221, 4, 4, 0.301)",
            borderRadius: "50%",
            padding: "10%",
            width: "20%",
            height: "20%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }
        },
        val
      );
    } else {
      return createElement(
        "span",
        {
          // class: "el-tag el-tag--danger el-tag--plain"
          style: {
            color: "black"
          }
        },
        ""
      );
    }
  }
};
</script>
